module.exports = "img/11.6c1c87.webp";